export default __webpack_public_path__ + "static/media/logo_zendesk.b38a7cd5.svg";